import EnumObject from '@/domain/enum-object.entity';
import RuleGroupItem from './rule-group-item.entity';
import RuleGroupItemParameter from './rule-group-item-parameter.entity';

export default class RuleGroup {
  id: string;

  name: string;

  createdBy: string;

  createdDate: string;

  status: EnumObject;

  businessUnitId: string;

  rules: RuleGroupItem[] = [];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.status = EnumObject.of(obj.status);
    this.createdBy = obj.createdBy || '';
    this.createdDate = obj.createdDate || '';
    this.businessUnitId = obj.businessUnitId || '';
    if (obj.rules) {
      this.rules = RuleGroupItem.ofList(obj.rules)
    }
    this.verifyRuleLength();
  }

  public static of(obj: any = {}): RuleGroup {
    return new RuleGroup(obj || {});
  }

  public static ofList(obj: any[]): RuleGroup[] {
    return obj.map(this.of);
  }

  verifyRuleLength() {
    if (this.rules.length === 0) {
      this.rules.push(RuleGroupItem.of({}));
    }
  }

  prepareToSend() {
    this.rules.forEach((el: RuleGroupItem) => el.parameters
      .forEach((p: RuleGroupItemParameter) => {
        p.validateFormatValues();
      }));
  }

  public approve() {
    this.status = EnumObject.of({ value: 'APPROVED', description: 'Aprovado' });
  }

  public waitingApprove() {
    this.status = EnumObject.of({ value: 'WAITING_APPROVAL', description: 'Aguardando aprovação' });
  }

  public isApproved(): boolean {
    return this.status.value === 'APPROVED';
  }
}
